/**
 * Load and interpret store data.
 */
import { LocalBusiness } from "../types";
import debug from "./debug";
import { findByPropValueFn } from "./helpers";
import api from "./api";
import { getStoredItemAsIs } from "./localStorage";
import appEvents from "./appEvents";

export let STORES: LocalBusiness[] = [];

/**
 * Load the store data from a URL (string) or from an array of LocalBusiness objects.
 */
export async function loadStores(
  input?: null | string | LocalBusiness[]
): Promise<LocalBusiness[]> {
  // Already loaded
  if (STORES.length) {
    return STORES;
  }

  // Load using dataset given
  if (input instanceof Array) {
    debug("[utils/stores] Using supplied stores data", { input });

    STORES = input;
  }
  // Use the API
  else {
    debug("[utils/stores] Loading the stores data from API.");

    const receivedStores = await api.getStores();

    // check if current store exists
    const selectedStoreId = getStoredItemAsIs("storeId");
    if (selectedStoreId) {
      const selectedStore = receivedStores.find(
        store => store.identifier === selectedStoreId
      );
      if (!selectedStore) {
        appEvents.trigger("app.resetStore");
      }
    }

    STORES = receivedStores;
  }

  return STORES;
}

/**
 * Get a store's object by its identifier.
 */
export async function getStoreById(
  identifier: any
): Promise<LocalBusiness | undefined> {
  const matchedStores = await loadStores().then(allStores =>
    allStores.filter(findByPropValueFn("identifier", identifier))
  );

  if (matchedStores.length) {
    return matchedStores[0];
  }
}

/**
 * Get many stores object by a specific prop's value.
 */
export async function getStoresBy(
  propName: string,
  propValue: any
): Promise<LocalBusiness | LocalBusiness[] | undefined> {
  return await loadStores().then(allStores =>
    allStores.filter(findByPropValueFn(propName, propValue))
  );
}

export default STORES;
